var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "club-container"
  }, [_c("van-pull-refresh", {
    on: {
      refresh: _vm.onRefresh
    },
    model: {
      value: _vm.isLoading,
      callback: function callback($$v) {
        _vm.isLoading = $$v;
      },
      expression: "isLoading"
    }
  }, [_c("div", {
    staticClass: "club"
  }, [_vm.videoData.length > 0 ? _c("van-list", {
    attrs: {
      finished: _vm.finished,
      "finished-text": _vm.$t("NoMoreContents")
    },
    on: {
      load: _vm.onLoad
    },
    model: {
      value: _vm.loading,
      callback: function callback($$v) {
        _vm.loading = $$v;
      },
      expression: "loading"
    }
  }, _vm._l(_vm.videoData, function (item, index) {
    return _c("van-cell", {
      key: index,
      staticClass: "club-item"
    }, [_c("div", {
      staticClass: "user"
    }, [_c("div", {
      staticClass: "user-info",
      on: {
        click: function click($event) {
          return _vm.toMe(item.user.userId);
        }
      }
    }, [_c("img", {
      staticClass: "img",
      attrs: {
        src: require("../../../assets/images/icon_avatar.png"),
        alt: ""
      }
    }), _c("div", {
      staticClass: "txt"
    }, [_c("span", {
      staticClass: "name"
    }, [_vm._v("Ben")]), _c("span", {
      staticClass: "date"
    }, [_vm._v("2021/05/23 16:30")])])]), _c("div", {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: item.isFollow,
        expression: "item.isFollow"
      }],
      staticClass: "follow"
    }, [_vm._v("Follow")]), _c("div", {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: !item.isFollow,
        expression: "!item.isFollow"
      }],
      staticClass: "unFollow"
    }, [_vm._v("Unfollow")])]), _c("div", {
      staticClass: "explain",
      on: {
        click: function click($event) {
          return _vm.toDetail(item.threadId);
        }
      }
    }, [_vm._v(" Support MG car, welcome friends to buy, choose your Favorite one. ")]), _c("div", {
      staticClass: "video-con"
    }, [_c("video", {
      attrs: {
        poster: require("../../../assets/images/O6.png"),
        controls: "",
        "x5-playsinline": "true",
        playsinline: "true",
        "webkit-playsinline": "true"
      }
    }, [_c("source", {
      attrs: {
        src: "",
        type: "video/mp4"
      }
    })]), _c("span", {
      staticClass: "length"
    }, [_vm._v("0:23")]), _c("div", {
      staticClass: "times"
    }, [_c("img", {
      attrs: {
        src: require("../../../assets/images/play.png"),
        alt: ""
      }
    }), _c("span", [_vm._v(_vm._s(_vm.$t("Times")))])])]), _c("div", {
      staticClass: "user-operate"
    }, [_c("div", {
      staticClass: "item-con"
    }, [_c("div", {
      staticClass: "item"
    }, [_c("img", {
      attrs: {
        src: require("../../../assets/images/Comments.png"),
        alt: ""
      }
    }), _c("span", [_vm._v("0")])]), _c("div", {
      staticClass: "item"
    }, [_c("img", {
      attrs: {
        src: require("../../../assets/images/Like.png"),
        alt: ""
      }
    }), _c("span", [_vm._v("0")])]), _c("div", {
      staticClass: "item"
    }, [_c("img", {
      attrs: {
        src: require("../../../assets/images/Collection.png"),
        alt: ""
      }
    }), _c("span", [_vm._v("0")])])]), _c("img", {
      attrs: {
        src: require("../../../assets/images/Share.png"),
        alt: ""
      }
    })])]);
  }), 1) : _vm._e()], 1)])], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };